var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-icon',{attrs:{"color":"info","left":""}},[_vm._v("\n        mdi-information-slab-box\n    ")]),_vm._v(" "),_c('span',{staticClass:"textGrey"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }